import { AlertTriangle, CheckCircle, Clock, Minus, XCircle } from "lucide-react";
import type { LucideIcon } from "lucide-react";

const STATUS_CONFIG: Record<string, { label: string; icon: LucideIcon; text: string; bg: string; border: string }> = {
  healthy: { label: "Healthy", icon: CheckCircle, text: "text-green-600", bg: "bg-green-50", border: "border-green-200" },
  degraded: { label: "Degraded", icon: AlertTriangle, text: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200" },
  down: { label: "Down", icon: XCircle, text: "text-red-600", bg: "bg-red-50", border: "border-red-200" },
  unconfigured: { label: "Not configured", icon: Minus, text: "text-gray-400", bg: "bg-gray-50", border: "border-gray-200" },
  unknown: { label: "Pending", icon: Clock, text: "text-gray-400", bg: "bg-gray-50", border: "border-gray-200" },
};

export function StatusBadge({ status }: { status?: string | null }) {
  const cfg = STATUS_CONFIG[status ?? ""] ?? STATUS_CONFIG.unknown;
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${cfg.bg} ${cfg.border} ${cfg.text}`}>
      <Icon size={11} />
      {cfg.label}
    </span>
  );
}

const SEVERITY_CONFIG: Record<string, { label: string; cls: string }> = {
  critical: { label: "Critical", cls: "border-red-200 bg-red-50 text-red-700" },
  high: { label: "High", cls: "border-orange-200 bg-orange-50 text-orange-700" },
  medium: { label: "Medium", cls: "border-amber-200 bg-amber-50 text-amber-600" },
  low: { label: "Low", cls: "border-gray-200 bg-gray-50 text-gray-500" },
  info: { label: "Info", cls: "border-gray-200 bg-gray-50 text-gray-500" },
};

export function SeverityBadge({ severity }: { severity?: string }) {
  const cfg = SEVERITY_CONFIG[severity ?? "medium"] ?? SEVERITY_CONFIG.medium;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}

export function IncidentBadge({ status }: { status?: string }) {
  if (status === "ongoing") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-2.5 py-0.5 text-xs font-medium text-red-700">
        <span className="relative flex h-1.5 w-1.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-500" />
        </span>
        Ongoing
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-green-200 bg-green-50 px-2.5 py-0.5 text-xs font-medium text-green-700">
      <CheckCircle size={11} />
      Resolved
    </span>
  );
}
